export function formatMessage(intlShape, ...[descriptor, parameters]) {
  return intlShape.formatMessage(descriptor, parameters, {
    ignoreTag: true
  });
}